<template>
	<div class="flex flex_center">
		<div class="w_40">
			<div class="text_center">
				<h4 class="font_lg font_bold">
					{{ $t("signUp.completion.title") }}
				</h4>
				<p>
					{{ $t("signUp.completion.text") }}
				</p>
			</div>
			<div class="flex flex_center">
				<md-button class="md-primary" @click="resend">
					{{ $t("common.button.resendMail") }}
				</md-button>
				<md-button v-if="hasRedirect" class="md-primary" @click="followRedirect" style="margin-left: 1rem">
					{{ $t("signUp.completion.btn.followRedirect", { partnerName: redirect.partnerName }) }}
				</md-button>
			</div>
		</div>
	</div>
</template>

<script>
import {registrationApi} from "@/common/api/registrationApi";
import {navigationPaths} from "@/common/navigation/navigationPaths";
import {mapActions, mapGetters} from "vuex";

export default {
	data() {
		return {
			email: "",
			redirect: {
				partnerName: "",
				redirectUrl: ""
			}
		};
	},
	beforeMount() {
		this.email = this.signUpData.userEmail;
		this.redirect = { ...this.signUpRedirect };
		
		this.clearSignUp();
	},
	beforeRouteLeave(to, from, next) {
		if (to.path.startsWith(navigationPaths.register.base)) {
			this.logout();
		}
		next();
	},
	computed: {
		...mapGetters({
			signUpData: "local/signUpData",
			signUpRedirect: "local/signUpRedirect"
		}),
		hasRedirect() {
			return !!this.redirect.redirectUrl;
		}
	},
	methods: {
		...mapActions({
			clearSignUp: "local/clearSignUp"
		}),
		resend() {
			if (this.email) {
				registrationApi.resendMail(this.email)
					.then(this.toastSuccess)
					.catch(this.toast);
			} else {
				this.$router.push(navigationPaths.login.help);
			}
		},
		followRedirect() {
			window.location.href = this.redirect.redirectUrl;
		}
	}
};
</script>
